<app-loader></app-loader>

<div class="page page-core page-login">

    <div class="text-center">
        <img class="logo-image" src="{{AppSettings.LOGO}}">
        <h3 class="text-light text-white">{{AppSettings.SITE_TITLE}}</h3>
    </div>



    <div class="container w-420 p-15 bg-white mt-40 text-center">


        <h2 class="text-light text-greensea">Super Admin</h2>

        <form class="form-validation mt-20" [formGroup]="loginForm" (submit)="onSubmit()">

            <div class="form-group">
                <input class="form-control underline-input" placeholder="Email" formControlName="username" [ngClass]="{ 'error-border': f.username.errors && (f.username.touched || f.username.dirty || submitted) }">

                <div *ngFor="let validation of login_validation_messages.username">
                    <div class="error-message" *ngIf="f.username.hasError(validation.type) && (f.username.touched || f.username.dirty || submitted)">{{validation.message}}
                    </div>
                </div>

            </div>

            <div class="form-group">
                <input type="password" placeholder="Password" class="form-control underline-input" formControlName="password" [ngClass]="{ 'error-border': f.password.errors && (f.password.touched || f.password.dirty || submitted) }">

                <div *ngFor="let validation of login_validation_messages.password">
                    <div class="error-message" *ngIf="f.password.hasError(validation.type) && (f.password.touched || f.password.dirty || submitted)">{{validation.message}}
                    </div>
                </div>

            </div>

            <div class="form-group text-center mt-20">
                <button type="submit" class="btn btn-greensea b-0 br-2 mr-5">Login</button>
            </div>

        </form>


    </div>

</div>